<!--
 * @LastEditors: taoyan taoyan_work@163.com
-->
<template>
<!-- 能不能吃搜索组件 -->
    <!-- 搜索 -->
    <div class="search_">
        <span class="back" @click="goBack">
            <van-icon name="arrow-left" />
        </span>
          <van-search
            class="vanSearch"
            v-model="searchText"
            placeholder="请输入食物名称"
            shape="round"
            @focus="goSearch"
        >
            <template v-slot:left-icon>
              <img class="search-img" src="@/assets/images/icon/search.png" />
            </template>
        </van-search>
    </div>
</template>

<script>
  import { isUserLogin ,globalGoLogin} from "@/assets/js/common.js";

  export default {
    name: 'Search',
    data() {
      return {
        isOff: false,
        searchText: ''
      }
    },
    props: {
      isShare: String,
      // isRefisterFlag: Boolean
    },
    methods: {
      isUserLogin,
      goBack() {
        // if() {

        // }
        console.log(this.$router, 42, this.isShare)
        if(!this.isShare) {
          this.$router.back(-1)
        } else {
          this.$router.push({
            path: '/home'
          })
        }
      },
      goSearch(val) {

        sensors.track('Eatable_ClickSearch', {
          page_name: '能不能吃',
          module_name:'能不能吃',
          per_page_name:'能不能吃',
          per_module_name:'能不能吃'
        })
        if(this.isUserLogin()) {//未zhuce
          // this.$router.push({ path: "/phoneLogin?redirect=" + window.location.href })
          globalGoLogin()
        } else {
          setTimeout(() => {
            this.$router.push({ path: '/canEatListSearch', query: { title: '能不能吃' } })
          }, 200)
        }
      }
    },
  }
</script>

<style lang="less" scoped>
/deep/ .van-field__value {
  padding-left: 14px;
}
/deep/ .van-field__control {
  line-height: 23px;
}
.search-img {
  width: 14px;
  position: absolute;
  top: 50%;
  margin-top: -9px;
}
.search_ {
  width: 100%;
  background: @expertFontColor255;
  overflow: hidden;
  padding-bottom: 12px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 98;
  .back {
    float: left;
    font-size: @indexFontSize20;
    padding-top: 19px;
    width: 22px;
    text-align: right;
    padding-left: 5px;
  }

  .van-search {
    width: 91%;
    padding: 13px 0 0 12px;
    font-size: @indexFontSize12;
    float: left;
    .van-search__action {
      padding: 0 12px;
      font-size: @indexFontSize14;
    }
  }
  .vanSearch1 {
    width: 90%;
    padding: 12px 0 0 12px;
  }
  @media screen and (max-width: 640px) {
    .vanSearch1 {
      width: 316px;
    }
  }
}
</style>
